import clsx from 'clsx'
import { ButtonBase, type DistinctBaseButtonProps, type SharedBaseButtonProps } from 'nextjs-button-base'
import type { FunctionComponent } from 'react'
import styles from './Button.module.sass'

export type ButtonProps = Omit<SharedBaseButtonProps, 'className'> &
	DistinctBaseButtonProps & {
		size?: 'default' | 'small'
		variant?: 'primary' | 'secondary'
		isCentered?: boolean
	}

export const Button: FunctionComponent<ButtonProps> = ({ children, isCentered, variant = 'primary', size = 'default', ...otherProps }) => {
	const buttonContent = (
		<ButtonBase className={clsx(styles.wrapper, styles[`is_size_${size}`], styles[`is_variant_${variant}`])} {...otherProps}>
			{children}
		</ButtonBase>
	)

	if (isCentered) {
		return <div className={styles.centered}>{buttonContent}</div>
	}

	return buttonContent
}
